module.exports = __webpack_public_path__ + "static/img/abort_back3.17ea231.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/abort_back3.png
// module id = XKW/
// module chunks = 0